// Expandable search button functionality
jQuery(document).ready(function(){
    jQuery('.search-toggle').click(function(e){
        e.preventDefault();
        jQuery('.search-form').toggleClass('active');
        jQuery('.search-form').hasClass('active') ? jQuery(this).attr('aria-expanded', 'true') : jQuery(this).attr('aria-expanded', 'false');
        if( jQuery('.search-form').hasClass('active') ){
            jQuery('.search-field').focus();
        }
    });
});

// Close the search form when clicking outside of it
jQuery(document).on('click', function(event){
	var target = jQuery(event.target);
	if(jQuery('.search-form').hasClass('active')){
		if(!target.hasClass('search-form') && !target.hasClass('search-label') && !target.hasClass('search-toggle') && !target.hasClass('search-field')){
			jQuery('.search-form').attr('aria-expanded', 'false');
			jQuery('.search-form').removeClass('active');
		}
	}
});